import React, { useEffect, useState } from "react";
import { Alert, Button, Modal } from "react-bootstrap";
import { useTranslation } from "react-i18next";

import { CatalogRecord, ResourceName } from "./CatalogAdmin.types.tsx";
import { failureMessages } from "./model.tsx";
import { resourceSpec } from "./resources.tsx";

import { deleteRecord } from "../../services/catalog.services.tsx";

interface DeleteRecordModalProps {
  resource: ResourceName;
  record: CatalogRecord | null;
  onHide: () => void;
  onDeleted: () => void;
}

const DeleteRecordModal: React.FC<DeleteRecordModalProps> = ({
  resource,
  record,
  onHide,
  onDeleted,
}) => {
  const { t } = useTranslation();
  const [busy, setBusy] = useState(false);
  const [messages, setMessages] = useState<string[]>([]);

  useEffect(() => {
    setMessages([]);
  }, [record]);

  const confirm = async () => {
    if (!record) {
      return;
    }

    setBusy(true);

    try {
      await deleteRecord(resource, record.id);
      onDeleted();
    } catch (error) {
      setMessages(failureMessages(error, () => false, t));
    } finally {
      setBusy(false);
    }
  };

  const name = record ? String(record.fields[resourceSpec(resource).searchField] ?? record.id) : "";

  return (
    <Modal show={record !== null} onHide={onHide} centered className="catalog-modal">
      <Modal.Header closeButton>
        <Modal.Title>{t("catalog.delete.title", { name })}</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <p>{t("catalog.delete.body")}</p>
        {messages.map((message) => (
          <Alert key={message} variant="danger">
            {message}
          </Alert>
        ))}
      </Modal.Body>
      <Modal.Footer>
        <Button variant="secondary" onClick={onHide}>
          {t("catalog.form.cancel")}
        </Button>
        <Button variant="danger" disabled={busy} onClick={confirm}>
          {t("catalog.delete.confirm")}
        </Button>
      </Modal.Footer>
    </Modal>
  );
};

export default DeleteRecordModal;
